module.exports = __webpack_public_path__ + "static/media/upload.88136545.svg";